module.exports = __webpack_public_path__ + "img/fête d'entreprise.d6f55d6a.png";